import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { error } from 'react-notification-system-redux';
import { notificationsConfig } from '../../../../../config/constants';
import { useFarmId } from '../../../InventoryWidget/useFarmId';
import { useDeviationsAPI } from './useDeviationsAPI';
import { WidgetType } from '../../../widget.types';
export const alertQueryKeysMap = {
    [WidgetType.DELIVER_DEVIATION]: ['deliverDeviationAlerts'],
    [WidgetType.LOAD_DEVIATION]: ['loadDeviationAlerts'],
};
const selectData = (data, widgetType) => {
    if (!data) {
        return [];
    }
    return data.map((dataItem) => {
        const { items, tolerance } = dataItem;
        const { deviation, driverName, rationName, dateTime, deviationPerc } = items[0];
        return {
            name: widgetType === WidgetType.DELIVER_DEVIATION ? dataItem.groupName : dataItem.ingredientName,
            data: {
                alertCount: items.length,
                deviation,
                deviationPerc,
                driverName,
                rationName,
                dateTime,
                tolerance,
                id: widgetType === WidgetType.DELIVER_DEVIATION ? dataItem.groupId : dataItem.ingredientId,
            },
            fill: deviation < 0 ? '#E46A68' : '#007DC5',
        };
    });
};
export const useDeviationAlertsQuery = (widgetType) => {
    const dispatch = useDispatch();
    const api = useDeviationsAPI(widgetType);
    const farmId = useFarmId();
    return useQuery({
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        onError: () => dispatch(error({
            ...notificationsConfig.defaultConf,
            translationKey: 'widget:widget:cant_load_widgets',
        })),
        enabled: !!farmId,
        queryFn: () => api.getAlerts(farmId),
        queryKey: alertQueryKeysMap[widgetType],
        select: (data) => selectData(data, widgetType),
    });
};
//# sourceMappingURL=useDeviationAlertsQuery.js.map